import { FC, memo } from 'react';
import Tooltip from 'antd/lib/tooltip';

import { userApprovalStatusSelector } from 'store/selectors/userSelectors';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { popoverContentByStatus, stylesByStatus, textByStatus } from 'components/Header/constants';

const UserStatus: FC = () => {
  const status = useTypedSelector(userApprovalStatusSelector);

  return (
    <Tooltip
      title={popoverContentByStatus[status]}
      placement="bottom"
      overlayClassName="max-w-[200px]"
      destroyTooltipOnHide
    >
      <div className={`rounded-3xl py-1 px-2.5 leading-4 font-regular ${stylesByStatus[status]}`}>
        {textByStatus[status]}
      </div>
    </Tooltip>
  );
};

export default memo(UserStatus);
